import React from 'react';
import { ProductItem } from './ProductItem';
import { parseProductItemType } from './icons/ProductIconWrapper';
import { Colors } from '../../../styles/colors';

export const AllProductItemTypesDebug = () => (
  <div style={{ padding: '5rem 0', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '.75rem' }}>
    {
      [
        'STROM', 'ERDGAS', 'STROM_ECO', 'TRANCHENMODELL_STROM', 'TRANCHENMODELL_ERDGAS', 'TRANCHENMODELL_ECO', 'TANKDEMONTAGE_ERDGAS',
        'EMOBILITY', 'ENERGIE_AUDIT', 'ECHTE_WAERME', 'DIGITALE_WOHNUNGSUEBERGABE', 'PHONE', 'WASSER'
      ].map((type) => (
        <ProductItem type={parseProductItemType(type)} color={Colors.primaryLight}>{ type }</ProductItem>
      ))
    }
  </div>
)
